<template>
  <div v-if="!widget.conditional" class="widget-button" @click="addWidget({ parentId, type: widget.type })">
    <i :class="`widget-button__icon ${widget.icon} fa-lg`" />

    <div class="widget-button__text">
      {{ widget.text }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'WidgetButton',
  props: {
    widget: {
      type: Object,
      required: true,
      validator: item => item.hasOwnProperty('icon') && item.hasOwnProperty('text') && item.hasOwnProperty('type'),
    },
    parentId: {
      type: String,
      required: true,
    },
  },
  methods: mapActions('landing', ['addWidget']),
}
</script>

<style lang="scss">
.widget-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  cursor: pointer;
  border: 1px solid $grey-20;
  border-radius: 4px;
  background-color: white;
  text-align: center;
  min-height: 113px;
}

.widget-button__icon {
  color: $cherry;
}

.widget-button__text {
  color: $grey;
  margin-top: 16px;
}
</style>
